import React, {useEffect, useContext} from 'react'
import {AppbarContentContext} from "../../routing/appbar/AppbarContentProvider";
import {useIntl} from "react-intl";
import logo from 'assets/judged_black_bg.png';
import {useStyles} from "./AboutSection.css";

const AboutSection = () => {
    const classes = useStyles()

    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({
                id: 'app.about.overview.appbar.header',
                defaultMessage: 'About'
            }),
            description: intl.formatMessage({
                id: 'app.about.overview.appbar.description',
                defaultMessage: 'Version & Support'
            }),
            actions: <>
            </>
        })
    }, [])

    return (
        <div>
            <img className={classes.logo} src={logo} alt='App logo'/>

            <p><b>{intl.formatMessage({
                id: 'app.about.details.version.label',
                defaultMessage: 'Version'
            })}:</b> {process.env.REACT_APP_VERSION}</p>

            <p><b>{intl.formatMessage({
                id: 'app.about.details.environment.label',
                defaultMessage: 'Environment'
            })}:</b> {process.env.REACT_APP_STAGE}</p>

            <p><b>{intl.formatMessage({
                id: 'app.about.details.contact.label',
                defaultMessage: 'Contact'
            })}:</b> {intl.formatMessage({
                id: 'app.about.details.contact.info',
                defaultMessage: '/'
            })}</p>
        </div>
    )
}

export default AboutSection
